import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onClick"];
import { Button } from 'foundations-components/transitional/components/Button';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getPropertyValue } from 'marketing-platform-lib/utils/crmUtils';
import EmbedVersions from 'forms-utils-lib/constants/formDefinition/EmbedVersions';
import { useAssetActions } from 'asset-actions-lib/context/AssetActionsContext';
import { getCurrentUrl } from 'asset-actions-lib-forms/utils/urlUtils';
import { getRouteForEditAction } from 'asset-actions-lib-forms/edit/editUrls';
import { jsx as _jsx } from "react/jsx-runtime";
export default function EditActionButton(_ref) {
  let {
      onClick
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    crmObject,
    layoutUse
  } = useAssetActions();
  const handleClick = () => {
    if (onClick) {
      onClick();
    }
    const isHoverActions = !layoutUse || layoutUse === 'hover-actions';
    const formType = getPropertyValue(crmObject, 'hs_form_type');
    const guid = getPropertyValue(crmObject, 'hs_form_id');
    const isAlpha = getPropertyValue(crmObject, 'hs_embed_version') === EmbedVersions.V4;
    const redirectUrl = isHoverActions ? getCurrentUrl() : '';
    window.location.href = getRouteForEditAction(guid, formType, isAlpha, redirectUrl);
  };
  return /*#__PURE__*/_jsx(Button, Object.assign({}, rest, {
    "data-test-id": "edit",
    onClick: handleClick,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: layoutUse === 'hover-actions' ? 'assetActionsLib.sharedActions.edit' : 'assetActionsLibForms.actions.edit'
    })
  }));
}